import { render } from "./CxHeightMapLegend.vue?vue&type=template&id=65579078"
import script from "./CxHeightMapLegend.vue?vue&type=script&lang=js"
export * from "./CxHeightMapLegend.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__